import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { combineStates, siteSettingsState, popupDispatcher } from '../../../store';
import { connect } from 'react-redux';
import { translate } from '../../../services';
import CookieConsent from "react-cookie-consent";
export class cookiesConsentComponent extends Component {
   
  render() {
     return <div className="App">
      <CookieConsent
      style={{textAlign:"center",background:"#fdfdfd",color:"black",justifyContent: "center"}}
      buttonText={ translate( 'IAgree' ) }
      expires={365}
      buttonStyle ={{ color:"white",background:"red",borderRadius:"23px"}}
      ><p>{ translate( 'Cookie-Banner' ) } <a  className="cookie-btn" href="https://new.abb.com/privacy-policy" target="ABBPrivacy">{translate('LearnMore')}</a></p>
      </CookieConsent>
    </div> 
  }
}

export const CookiesConsent = connect( combineStates(  siteSettingsState ), popupDispatcher) (cookiesConsentComponent) ;